module.exports = __webpack_public_path__ + "img/76.72919248.webp";